import { lazy, Suspense, useContext, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import LoadingScreen from 'components/LoadingScreen';

import LayoutV3 from 'layouts/layout-v3/DashboardLayout';
import { UserContext } from 'contexts/UserContext';
import { filterRoutes } from 'utils/permissions';
import { Tag } from '@mui/icons-material';

const Loadable = Component => props => {
	return (
		<Suspense fallback={<LoadingScreen />}>
			<Component {...props} />
		</Suspense>
	);
};

// const PrivacyPolicy = Loadable(lazy(() => import("../pages/PrivacyPolicyPage")))

// dashboards
const Dashboard = Loadable(lazy(() => import('pages/dashboards/Dashboard')));
const DashboardPatent = Loadable(
	lazy(() => import('pages/dashboards/patent/Dashboard'))
);
const PrivacyPolicyPage = Loadable(
	lazy(() => import('pages/PrivacyPolicyPage'))
);

// Contacts
const ContactList = Loadable(lazy(() => import('pages/contact')));
const EditContact = Loadable(lazy(() => import('pages/contact/EditContact')));
const PatentContactList = Loadable(lazy(() => import('pages/contactPatent')));
const PatentEditContact = Loadable(
	lazy(() => import('pages/contactPatent/EditContact'))
);
const IndustriContactList = Loadable(lazy(() => import('pages/contactDI')));
const IndustriEditContact = Loadable(
	lazy(() => import('pages/contactDI/EditContact'))
);

// payment item
const PaymentItemList = Loadable(
	lazy(() => import('pages/master-data/paymentItem'))
);
const FormPaymentITem = Loadable(
	lazy(() => import('pages/master-data/paymentItem/formItem'))
);

// Company
const CompanyList = Loadable(lazy(() => import('pages/master-data/company')));
const AddCompany = Loadable(
	lazy(() => import('pages/master-data/company/AddCompany'))
);
const EditCompany = Loadable(
	lazy(() => import('pages/master-data/company/EditCompany'))
);

// master consultant
const ConsultantList = Loadable(
	lazy(() => import('pages/master-data/consultant'))
);
const FormConsultant = Loadable(
	lazy(() => import('pages/master-data/consultant/FormConsultant'))
);

const MessageList = Loadable(lazy(() => import('pages/message')));
const AddMessage = Loadable(lazy(() => import('pages/message/Detail')));
const EditMessage = Loadable(lazy(() => import('pages/message/Detail')));

// publication
const PublicationList = Loadable(
	lazy(() => import('pages/trademark/publication'))
);
const PublicationDetail = Loadable(
	lazy(() => import('pages/trademark/publication/Detail'))
);

// filingreport
const FilingReportList = Loadable(
	lazy(() => import('pages/trademark/filingreport'))
);
const FilingReportDetail = Loadable(
	lazy(() => import('pages/trademark/filingreport/Detail'))
);

// Status
const StatusRegList = Loadable(lazy(() => import('pages/trademark/statusreg')));
const StatusRegDetail = Loadable(
	lazy(() => import('pages/trademark/statusreg/Detail'))
);
const StatusRegForm = Loadable(
	lazy(() => import('pages/trademark/statusreg/Form'))
);
const StatusRegFormDetail = Loadable(
	lazy(() => import('pages/trademark/statusreg/FormComplete'))
);

// Status DN
const StatusRegDNList = Loadable(
	lazy(() => import('pages/trademark/statusregDN'))
);
const StatusRegDNDetail = Loadable(
	lazy(() => import('pages/trademark/statusregDN/Detail'))
);
const StatusRegDNForm = Loadable(
	lazy(() => import('pages/trademark/statusregDN/Form'))
);
const StatusRegDNFormDetail = Loadable(
	lazy(() => import('pages/trademark/statusregDN/FormComplete'))
);

// certificate
const CertificateList = Loadable(
	lazy(() => import('pages/trademark/certificate'))
);
const CertificateDetail = Loadable(
	lazy(() => import('pages/trademark/certificate/Detail'))
);

// office action
const OfficeActionList = Loadable(
	lazy(() => import('pages/trademark/officeaction'))
);
const OfficeActionDetail = Loadable(
	lazy(() => import('pages/trademark/officeaction/Detail'))
);
const OAEventDetail = Loadable(
	lazy(() => import('pages/trademark/officeaction/EventDetail'))
);
const OfficeActionNewForm = Loadable(
	lazy(() => import('pages/trademark/officeaction/NewForm'))
);
const OfficeActionFormComplete = Loadable(
	lazy(() => import('pages/trademark/officeaction/FormComplete'))
);
const OfficeActionResult = Loadable(
	lazy(() => import('pages/trademark/officeaction/Result'))
);
const OfficeActionEventResult = Loadable(
	lazy(() => import('pages/trademark/officeaction/ResultEvent'))
);

// Legal
const LegalListPage = Loadable(lazy(() => import('pages/trademark/legal')));
const LegalDetailPage = Loadable(
	lazy(() => import('pages/trademark/legal/Detail'))
);
const LegalMatterPage = Loadable(
	lazy(() => import('pages/trademark/legal/EventDetail'))
);
// const LegalFormPage = Loadable(lazy(() => import("pages/trademark/legal/Form")))
const LegalFormPage = Loadable(
	lazy(() => import('pages/trademark/legal/NewForm'))
);
const LegalFormComplete = Loadable(
	lazy(() => import('pages/trademark/legal/FormComplete'))
);
const LegalResult = Loadable(
	lazy(() => import('pages/trademark/legal/Result'))
);
const LegalEventResult = Loadable(
	lazy(() => import('pages/trademark/legal/ResultEvent'))
);

// Event
const EventList = Loadable(lazy(() => import('pages/event')));
const EventAdd = Loadable(lazy(() => import('pages/event/BuatEvent')));

// master tax rate
const TaxRateList = Loadable(lazy(() => import('pages/master-data/taxrate')));
const TaxRateForm = Loadable(
	lazy(() => import('pages/master-data/taxrate/form'))
);

// Tasks
const TasksList = Loadable(lazy(() => import('pages/master-data/tasks')));

// Roles
const RolePage = Loadable(
	lazy(() => import('pages/master-data/role/ListRole'))
);

// Roles
const DepartementPage = Loadable(
	lazy(() => import('pages/master-data/departement'))
);

// Users
const UserPage = Loadable(
	lazy(() => import('pages/master-data/users/ListUser'))
);

const LoginV2 = Loadable(lazy(() => import('pages/authentication/login-v2')));
const Error = Loadable(lazy(() => import('pages/404')));
// tasks unwind
const RequestTaskList = Loadable(lazy(() => import('pages/tasks/index')));

// notifications
const NotificationPage = Loadable(lazy(() => import('pages/notifications')));

// renewal
const RenewalPage = Loadable(lazy(() => import('pages/trademark/renewal')));
const RenewalFormPage = Loadable(
	lazy(() => import('pages/trademark/renewal/Form'))
);
const RenewalFormComplete = Loadable(
	lazy(() => import('pages/trademark/renewal/FormComplete'))
);
const RenewalDetail = Loadable(
	lazy(() => import('pages/trademark/renewal/Detail'))
);
const RenewalResult = Loadable(
	lazy(() => import('pages/trademark/renewal/Result'))
);

// recordal
const RecordalPage = Loadable(lazy(() => import('pages/trademark/recordal')));
const RecordalFormPage = Loadable(
	lazy(() => import('pages/trademark/recordal/Form'))
);
const RecordalFormComplete = Loadable(
	lazy(() => import('pages/trademark/recordal/FormComplete'))
);
const RecordalDetail = Loadable(
	lazy(() => import('pages/trademark/recordal/Detail'))
);
const RecordalResult = Loadable(
	lazy(() => import('pages/trademark/recordal/Result'))
);

// search
const SearchPage = Loadable(lazy(() => import('pages/trademark/search')));
const SearchFormPage = Loadable(
	lazy(() => import('pages/trademark/search/Form'))
);
const SearchFormComplete = Loadable(
	lazy(() => import('pages/trademark/search/FormComplete'))
);
const SearchDetail = Loadable(
	lazy(() => import('pages/trademark/search/Detail'))
);
const SearchResult = Loadable(
	lazy(() => import('pages/trademark/search/Result'))
);

// invoices
const InvoicePage = Loadable(lazy(() => import('pages/invoices')));
const InvoiceDetail = Loadable(lazy(() => import('pages/invoices/Detail')));
const ResultInvoice = Loadable(lazy(() => import('pages/invoices/Result')));
const InvoiceCustomForm = Loadable(
	lazy(() => import('pages/invoices/CustomForm'))
);
const InvoiceProduction = Loadable(
	lazy(() => import('pages/report/production'))
);
const InvoiceCustomFormPaten = Loadable(
	lazy(() => import('pages/invoices/CustomFormPatenV2'))
);
const InvoiceCustomFormDI = Loadable(
	lazy(() => import('pages/invoices/CustomFormDIV2'))
);

const InvoiceCustomFormOaPaten = Loadable(
	lazy(() => import('pages/invoices/CustomFormOaPaten'))
);

// report template
const ReportTemplatePage = Loadable(lazy(() => import('pages/templates')));

// efiling
const EfilingPage = Loadable(lazy(() => import('pages/trademark/efiling')));
const EfilingForm = Loadable(
	lazy(() => import('pages/trademark/efiling/Form'))
);
const EfilingFormComplete = Loadable(
	lazy(() => import('pages/trademark/efiling/FormComplete'))
);
const EfilingDetail = Loadable(
	lazy(() => import('pages/trademark/efiling/Detail'))
);
const EfilingResult = Loadable(
	lazy(() => import('pages/trademark/efiling/Result'))
);

// efiling DN
const EfilingDNPage = Loadable(lazy(() => import('pages/trademark/efilingDN')));
const EfilingDNForm = Loadable(
	lazy(() => import('pages/trademark/efilingDN/Form'))
);
const EfilingDNFormComplete = Loadable(
	lazy(() => import('pages/trademark/efilingDN/FormComplete'))
);
const EfilingDNDetail = Loadable(
	lazy(() => import('pages/trademark/efilingDN/Detail'))
);
const EfilingDNResult = Loadable(
	lazy(() => import('pages/trademark/efilingDN/Result'))
);

const ReportBook = Loadable(lazy(() => import('pages/report/books')));

// all report detail
const ReportBookDetail = Loadable(
	lazy(() => import('pages/report/detail/Detail'))
);
const ReportBookResult = Loadable(
	lazy(() => import('pages/report/detail/Result'))
);
const ReportPatentDetail = Loadable(
	lazy(() => import('pages/report/detail/DetailPatent'))
);

const AdastraBookReport = Loadable(lazy(() => import('pages/report/adastra')));

const AffaBookReport = Loadable(lazy(() => import('pages/report/affa')));

const AkiBookReport = Loadable(lazy(() => import('pages/report/aki')));

const ArwanaBookReport = Loadable(lazy(() => import('pages/report/arwana')));

const AviaBookReport = Loadable(lazy(() => import('pages/report/avia')));

const ReportInvoice = Loadable(lazy(() => import('pages/report/invoice')));

// report search
const ReportSearch = Loadable(lazy(() => import('pages/report/search')));
const ReportDetailSearch = Loadable(
	lazy(() => import('pages/report/search/Detail'))
);

// report oa
const ReportOAList = Loadable(lazy(() => import('pages/report/oareport')));
const ReportOADetail = Loadable(
	lazy(() => import('pages/report/oareport/Detail'))
);
const ReportOAEventDetail = Loadable(
	lazy(() => import('pages/report/oareport/EventDetail'))
);

const ReportLegalList = Loadable(
	lazy(() => import('pages/report/legalreport'))
);
const ReportLegalDetail = Loadable(
	lazy(() => import('pages/report/legalreport/Detail'))
);
const ReportLegalEventDetail = Loadable(
	lazy(() => import('pages/report/legalreport/EventDetail'))
);

// accounts
const AccountPage = Loadable(lazy(() => import('pages/accounts/account')));

// PATENT
// efilingpatent
const ListEfilingPatent = Loadable(lazy(() => import('pages/patent/efiling')));
const EfilingPatentForm = Loadable(
	lazy(() => import('pages/patent/efiling/Form'))
);
const EfilingPatentNextForm = Loadable(
	lazy(() => import('pages/patent/efiling/FormComplete'))
);
const EfilingPatentDetail = Loadable(
	lazy(() => import('pages/patent/efiling/Detail'))
);
const EfilingPatentResult = Loadable(
	lazy(() => import('pages/patent/efiling/Result'))
);

// formality patent
const ListFormalityPatent = Loadable(
	lazy(() => import('pages/patent/formalitas'))
);
const FormalityPatentDetail = Loadable(
	lazy(() => import('pages/patent/formalitas/Detail'))
);

// publication patent
const ListPublicationPatent = Loadable(
	lazy(() => import('pages/patent/publikasi'))
);
const PublicationPatentDetail = Loadable(
	lazy(() => import('pages/patent/publikasi/Detail'))
);

// substantive patent
const ListSubstantivePatent = Loadable(
	lazy(() => import('pages/patent/substantive'))
);
const SubstantivePatentDetail = Loadable(
	lazy(() => import('pages/patent/substantive/Detail'))
);

// registrasi patent
const ListRegistrasiPatent = Loadable(
	lazy(() => import('pages/patent/status'))
);
const RegistrasiPatentDetail = Loadable(
	lazy(() => import('pages/patent/status/Detail'))
);

// sertifikat patent
const ListSertifikatPatent = Loadable(
	lazy(() => import('pages/patent/sertifikat'))
);
const SertifikatPatentDetail = Loadable(
	lazy(() => import('pages/patent/sertifikat/Detail'))
);

// renewal patent
const ListRenewalPatent = Loadable(lazy(() => import('pages/patent/renewal')));
const RenewalPatentDetail = Loadable(
	lazy(() => import('pages/patent/renewal/Detail'))
);
const RenewalPatentForm = Loadable(
	lazy(() => import('pages/patent/renewal/Form'))
);
const RenewalPatentNextForm = Loadable(
	lazy(() => import('pages/patent/renewal/FormComplete'))
);

// recordal patent
const ListRecordalPatent = Loadable(
	lazy(() => import('pages/patent/recordal'))
);
const RecordalPatentDetail = Loadable(
	lazy(() => import('pages/patent/recordal/Detail'))
);
const RecordalPatentForm = Loadable(
	lazy(() => import('pages/patent/recordal/Form'))
);
const RecordalPatentNextForm = Loadable(
	lazy(() => import('pages/patent/recordal/FormComplete'))
);
const RecordalPatentResult = Loadable(
	lazy(() => import('pages/patent/recordal/Result'))
);

// office action patent
const ListOAPatent = Loadable(lazy(() => import('pages/patent/officeaction')));
const OAPatentDetail = Loadable(
	lazy(() => import('pages/patent/officeaction/Detail'))
);
const OAEventPatentDetail = Loadable(
	lazy(() => import('pages/patent/officeaction/EventDetail'))
);

// search patent
const ListSearchPatent = Loadable(lazy(() => import('pages/patent/search')));
const SearchFormPatent = Loadable(
	lazy(() => import('pages/patent/search/Form'))
);
const SearchFormCompletePatent = Loadable(
	lazy(() => import('pages/patent/search/FormComplete'))
);
const DetailSearchPatent = Loadable(
	lazy(() => import('pages/patent/search/Detail'))
);
const ResultSearchPatent = Loadable(
	lazy(() => import('pages/patent/search/Result'))
);

// PPH PATENT
const ListPphPatent = Loadable(lazy(() => import('pages/patent/pph')));
const PphPatentDetail = Loadable(lazy(() => import('pages/patent/pph/Detail')));

// ASPEK PATENT
const ListAspekPatent = Loadable(lazy(() => import('pages/patent/aspek')));
const AspekPatentDetail = Loadable(
	lazy(() => import('pages/patent/aspek/Detail'))
);

// VOLUNTARY PATENT
const ListVolutaryPatent = Loadable(
	lazy(() => import('pages/patent/volutary'))
);
const VolutaryPatentDetail = Loadable(
	lazy(() => import('pages/patent/volutary/Detail'))
);

const Routes = isAuth => {
	const { dataUser, getDataUser } = useContext(UserContext);
	const permissions = dataUser.permissions || [];

	return [
		...authRoutes(isAuth),
		{
			path: '',
			element: isAuth ? <LayoutV3 /> : <Navigate to="/login" />,
			children: dashboardRoutes(permissions),
		},
		{
			path: '/privacy-policy', // Public route for the Privacy Policy
			element: <PrivacyPolicyPage />,
		},
		{
			path: '*',
			element: isAuth ? <LayoutV3 /> : <Navigate to="/login" />,
		},
	];
};

const authRoutes = isAuth => [
	{
		path: '/',
		element: !isAuth ? <Navigate to="/login" /> : <Navigate to="/dashboard" />,
	},
	{
		path: 'login',
		element: !isAuth ? <LoginV2 /> : <Navigate to="/dashboard" />,
	},
];

const dashboardRoutes = permissions => {
	const routes = [
		{
			path: 'dashboard',
			element: <Dashboard />,
		},
		{
			path: 'dashboard/patent',
			element: <DashboardPatent />,
		},
		{
			path: 'account',
			element: <AccountPage />,
			// permission: "profi:all"
		},
		{
			path: 'role',
			element: <RolePage />,
			permission: 'roles:all',
		},
		{
			path: 'users',
			element: <UserPage />,
			permission: 'users:all',
		},
		{
			path: 'invoices',
			permission: 'invoices:all',
			children: [
				{
					path: '',
					element: <InvoicePage />,
				},
				{
					path: 'create/',
					permission: 'invoices:add',
					element: <InvoiceCustomForm />,
				},
				{
					path: 'create/:_id',
					permission: 'invoices:edit',
					element: <InvoiceCustomForm />,
				},
				{
					path: 'detail/:_id',
					permission: 'invoices:byid',
					element: <InvoiceDetail />,
				},
				{
					path: 'create/paten/',
					permission: 'invoices:add',
					element: <InvoiceCustomFormPaten />,
				},
				{
					path: 'create/paten/:_id',
					permission: 'invoices:edit',
					element: <InvoiceCustomFormPaten />,
				},
				{
					path: 'create/desainIndustri/',
					permission: 'invoices:add',
					element: <InvoiceCustomFormDI />,
				},
				{
					path: 'create/desainIndustri/:_id',
					permission: 'invoices:edit',
					element: <InvoiceCustomFormDI />,
				},

				{
					path: 'create/paten/oa',
					permission: 'invoices:add',
					element: <InvoiceCustomFormOaPaten />,
				},
				{
					path: 'create/paten/oa/:_id',
					permission: 'invoices:edit',
					element: <InvoiceCustomFormOaPaten />,
				},

				// {
				// 	path: "soa",
				// 	permission: "invoices:add",
				// 	element: <SOAInvoicePage />
				// },
				{
					path: 'result',
					element: <ResultInvoice />,
				},
			],
		},

		{
			path: 'templates',
			permission: 'templates:all',
			children: [
				{
					path: '',
					element: <ReportTemplatePage />,
				},
			],
		},
		{
			path: 'contact',
			permission: 'contact:all',
			children: [
				{
					path: '',
					element: <ContactList />,
				},
				{
					path: 'form',
					permission: 'contact:add',
					children: [
						{
							path: '',
							element: <EditContact />,
						},
						{
							path: ':_id',
							element: <EditContact />,
						},
						// {
						// 	path: "preview",
						// 	element: <AddContact preview={true} />
						// }
					],
				},

				{
					path: 'detail/:_id',
					permission: 'contact:byid',
					element: <EditContact preview={true} />,
				},
			],
		},
		{
			path: 'cpatent',
			permission: 'contactpatent:all',
			children: [
				{
					path: '',
					element: <PatentContactList />,
				},
				{
					path: 'form',
					permission: 'contactpatent:add',
					children: [
						{
							path: '',
							element: <PatentEditContact />,
						},
						{
							path: ':_id',
							element: <PatentEditContact />,
						},
					],
				},

				{
					path: 'detail/:_id',
					permission: 'contactpatent:byid',
					element: <PatentEditContact preview={true} />,
				},
			],
		},
		{
			path: 'cindustri',
			permission: 'contactindustri:all',
			children: [
				{
					path: '',
					element: <IndustriContactList />,
				},
				{
					path: 'form',
					permission: 'contactindustri:add',
					children: [
						{
							path: '',
							element: <IndustriEditContact />,
						},
						{
							path: ':_id',
							element: <IndustriEditContact />,
						},
					],
				},

				{
					path: 'detail/:_id',
					permission: 'contactindustri:byid',
					element: <IndustriEditContact preview={true} />,
				},
			],
		},
		{
			path: 'pitem',
			permission: 'invoices:all',
			children: [
				{
					path: '',
					element: <PaymentItemList />,
				},
				{
					path: 'form',
					permission: 'invoices:add',
					children: [
						{
							path: '',
							element: <FormPaymentITem />,
						},
						{
							path: ':_id',
							element: <FormPaymentITem />,
						},
					],
				},
			],
		},

		{
			path: 'message',
			permission: 'message:all',
			children: [
				{
					path: '',
					element: <MessageList />,
				},
				{
					path: ':type',
					element: <MessageList />,
				},
				{
					path: 'detail/:type/:_id',
					permission: 'message:byid',
					element: <EditMessage preview={true} />,
				},
			],
		},
		// trademark
		{
			path: 'trademark',
			children: [
				{
					path: 'efiling',
					permission: 'filing:all',
					children: [
						{
							path: '',
							element: <EfilingPage />,
						},
						{
							path: 'create',
							element: <EfilingForm />,
							permission: 'filing:add',
						},
						{
							path: 'create/:_id',
							element: <EfilingFormComplete />,
							permission: 'filing:add',
						},
						{
							path: 'detail/:_id',
							element: <EfilingDetail />,
							permission: 'filing:byid',
						},
						{
							path: 'result/:_id',
							element: <EfilingResult />,
							permission: 'filing:all',
						},
					],
				},
				{
					path: 'efilingdn',
					permission: 'filingdn:all',
					children: [
						{
							path: '',
							element: <EfilingDNPage />,
						},
						{
							path: 'create',
							element: <EfilingDNForm />,
							permission: 'filingdn:add',
						},
						{
							path: 'create/:_id',
							element: <EfilingDNFormComplete />,
							permission: 'filingdn:add',
						},
						{
							path: 'detail/:_id',
							element: <EfilingDNDetail />,
							permission: 'filingdn:byid',
						},
						{
							path: 'result/:_id',
							element: <EfilingDNResult />,
							permission: 'filingdn:all',
						},
					],
				},

				{
					path: 'publication',
					permission: 'publication:all',
					children: [
						{
							path: '',
							element: <PublicationList />,
						},
						{
							path: 'detail/:_id',
							element: <PublicationDetail />,
						},

						{
							path: 'result/:_id',
							element: <EfilingResult />,
							permission: 'publication:all',
						},
					],
				},
				{
					path: 'filingreport',
					permission: 'filingreport:all',
					children: [
						{
							path: '',
							element: <FilingReportList />,
						},
						{
							path: 'detail/:_id',
							element: <FilingReportDetail />,
						},
						{
							path: 'result/:_id',
							element: <EfilingResult />,
							permission: 'filingreport:all',
						},
					],
				},
				{
					path: 'status',
					permission: 'status:all',
					children: [
						{
							path: '',
							element: <StatusRegList />,
						},
						{
							path: 'detail/:_id',
							element: <StatusRegDetail />,
						},
						{
							path: 'create',
							element: <StatusRegForm />,
							permission: 'status:add',
						},
						{
							path: 'create/:_id',
							element: <StatusRegFormDetail />,
							permission: 'status:add',
						},
						{
							path: 'result/:_id',
							element: <EfilingResult />,
							permission: 'status:all',
						},
					],
				},
				{
					path: 'statusdn',
					permission: 'statusdn:all',
					children: [
						{
							path: '',
							element: <StatusRegDNList />,
						},
						{
							path: 'detail/:_id',
							element: <StatusRegDNDetail />,
						},
						{
							path: 'create',
							element: <StatusRegDNForm />,
							permission: 'statusdn:add',
						},
						{
							path: 'create/:_id',
							element: <StatusRegDNFormDetail />,
							permission: 'statusdn:add',
						},
						{
							path: 'result/:_id',
							element: <EfilingResult />,
							permission: 'statusdn:all',
						},
					],
				},
				{
					path: 'certificate',
					permission: 'certificate:all',
					children: [
						{
							path: '',
							element: <CertificateList />,
						},
						{
							path: 'detail/:_id',
							element: <CertificateDetail />,
						},

						{
							path: 'result/:_id',
							element: <EfilingResult />,
							permission: 'certificate:all',
						},
					],
				},
				{
					path: 'officeaction',
					permission: 'officeaction:all',
					children: [
						{
							path: '',
							element: <OfficeActionList />,
						},
						{
							path: 'detail/:_id',
							element: <OfficeActionDetail />,
						},
						{
							path: 'event/:_id',
							element: <OAEventDetail />,
						},
						{
							path: 'create',
							element: <OfficeActionNewForm />,
						},
						{
							path: 'create/:_id',
							element: <OfficeActionFormComplete />,
						},
						{
							path: 'result/:_id',
							element: <OfficeActionResult />,
							permission: 'officeaction:all',
						},
						{
							path: 'event/result/:_id',
							element: <OfficeActionEventResult />,
							permission: 'officeaction:all',
						},
					],
				},
				{
					path: 'legal',
					permission: 'legal:all',
					children: [
						{
							path: '',
							element: <LegalListPage />,
						},
						{
							path: 'detail/:_id',
							element: <LegalDetailPage />,
						},
						{
							path: 'event/:_id',
							element: <LegalMatterPage />,
						},
						{
							path: 'create',
							element: <LegalFormPage />,
						},
						{
							path: 'create/:_id',
							element: <LegalFormComplete />,
						},
						{
							path: 'result/:_id',
							element: <LegalResult />,
							permission: 'legal:all',
						},
						{
							path: 'event/result/:_id',
							element: <LegalEventResult />,
							permission: 'legal:all',
						},
					],
				},
				{
					path: 'search',
					permission: 'search:all',
					children: [
						{
							path: '',
							element: <SearchPage />,
						},
						{
							path: 'detail/:_id',
							element: <SearchDetail />,
						},

						{
							path: 'create',
							element: <SearchFormPage />,
						},
						{
							path: 'create/:_id',
							element: <SearchFormComplete />,
						},
						{
							path: 'result/:_id',
							element: <SearchResult />,
							permission: 'search:all',
						},
					],
				},
				{
					path: 'renewal',
					permission: 'renewal:all',
					children: [
						{
							path: '',
							element: <RenewalPage />,
						},
						{
							path: 'detail/:_id',
							element: <RenewalDetail />,
						},
						{
							path: 'create',
							element: <RenewalFormPage />,
							permission: 'renewal:add',
						},
						{
							path: 'create/:_id',
							element: <RenewalFormComplete />,
							permission: 'renewal:add',
						},
						{
							path: 'result/:_id',
							element: <RenewalResult />,
							permission: 'renewal:all',
						},
					],
				},
				{
					path: 'recordal',
					permission: 'recordal:all',
					children: [
						{
							path: '',
							element: <RecordalPage />,
						},
						{
							path: 'detail/:_id',
							element: <RecordalDetail />,
						},
						{
							path: 'create',
							element: <RecordalFormPage />,
							permission: 'recordal:add',
						},
						{
							path: 'create/:_id',
							element: <RecordalFormComplete />,
							permission: 'recordal:add',
						},
						{
							path: 'result/:_id',
							element: <RecordalResult />,
							permission: 'recordal:byid',
						},
					],
				},
			],
		},

		// report
		{
			path: 'report',
			children: [
				{
					path: 'books',
					permission: 'report:all',
					children: [
						{
							path: '',
							element: <ReportBook />,
						},
						{
							path: 'detail/:_id',
							element: <ReportBookDetail />,
						},
						{
							path: 'patent/:_id',
							element: <ReportPatentDetail />,
						},
						{
							path: 'result/:_id',
							element: <ReportBookResult />,
						},
					],
				},

				{
					path: 'affa',
					permission: 'report:all',
					children: [
						{
							path: '',
							element: <AffaBookReport />,
						},
						{
							path: 'detail/:_id',
							element: <ReportBookDetail />,
						},
						{
							path: 'patent/:_id',
							element: <ReportPatentDetail path={'affa'} />,
						},
						{
							path: 'presult/:_id',
							element: <EfilingPatentResult disabled />,
						},
						{
							path: 'result/:_id',
							element: <ReportBookResult />,
						},
					],
				},

				{
					path: 'aki',
					permission: 'report:all',
					children: [
						{
							path: '',
							element: <AkiBookReport />,
						},
						{
							path: 'detail/:_id',
							element: <ReportBookDetail />,
						},
						{
							path: 'patent/:_id',
							element: <ReportPatentDetail path={'aki'} />,
						},
						{
							path: 'presult/:_id',
							element: <EfilingPatentResult disabled />,
						},
						{
							path: 'result/:_id',
							element: <ReportBookResult />,
						},
					],
				},

				{
					path: 'arwana',
					permission: 'report:all',
					children: [
						{
							path: '',
							element: <ArwanaBookReport />,
						},
						{
							path: 'detail/:_id',
							element: <ReportBookDetail />,
						},
						{
							path: 'patent/:_id',
							element: <ReportPatentDetail path={'arwana'} />,
						},
						{
							path: 'presult/:_id',
							element: <EfilingPatentResult disabled />,
						},
						{
							path: 'result/:_id',
							element: <ReportBookResult />,
						},
					],
				},

				{
					path: 'adastra',
					permission: 'report:all',
					children: [
						{
							path: '',
							element: <AdastraBookReport />,
						},
						{
							path: 'detail/:_id',
							element: <ReportBookDetail />,
						},
						{
							path: 'patent/:_id',
							element: <ReportPatentDetail path={'adastra'} />,
						},
						{
							path: 'presult/:_id',
							element: <EfilingPatentResult disabled />,
						},
						{
							path: 'result/:_id',
							element: <ReportBookResult />,
						},
					],
				},

				{
					path: 'avia',
					permission: 'report:all',
					children: [
						{
							path: '',
							element: <AviaBookReport />,
						},
						{
							path: 'detail/:_id',
							element: <ReportBookDetail />,
						},
						{
							path: 'patent/:_id',
							element: <ReportPatentDetail path={'avia'} />,
						},
						{
							path: 'presult/:_id',
							element: <EfilingPatentResult disabled />,
						},
						{
							path: 'result/:_id',
							element: <ReportBookResult />,
						},
					],
				},
				{
					path: 'search',
					permission: 'report:all',
					children: [
						{
							path: '',
							element: <ReportSearch />,
						},
						{
							path: 'patent/:_id',
							element: <ReportPatentDetail path={'search'} />,
						},
						{
							path: 'presult/:_id',
							element: <ResultSearchPatent disabled />,
						},
						{
							path: 'detail/:_id',
							element: <ReportDetailSearch />,
						},
					],
				},
				{
					path: 'production',
					permission: 'invoices:add',
					element: <InvoiceProduction />,
				},

				// {
				// 	path: "invoices",
				// 	permission: "report:all",
				// 	element: <ReportInvoice />
				// },

				{
					path: 'oareport',
					permission: 'report:all',
					children: [
						{
							path: '',
							element: <ReportOAList />,
						},
						{
							path: 'detail/:_id',
							element: <ReportOADetail />,
						},
						{
							path: 'event/:_id',
							element: <ReportOAEventDetail />,
						},
						{
							path: 'result/:_id',
							element: <EfilingResult />,
							permission: 'report:all',
						},
					],
				},
				{
					path: 'legalreport',
					permission: 'report:all',
					children: [
						{
							path: '',
							element: <ReportLegalList />,
						},
						{
							path: 'detail/:_id',
							element: <ReportLegalDetail />,
						},
						{
							path: 'event/:_id',
							element: <ReportLegalEventDetail />,
						},
						{
							path: 'result/:_id',
							element: <EfilingResult />,
							permission: 'report:all',
						},
					],
				},
			],
		},

		// patent
		{
			path: 'patent',
			// permission: "patent:all",
			children: [
				{
					path: 'efiling',
					permission: 'patent:all',
					children: [
						{
							path: '',
							element: <ListEfilingPatent />,
						},
						{
							path: 'create',
							element: <EfilingPatentForm subdiv="efiling" />,
							// permission: "filing:add"
						},
						{
							path: 'create/:_id',
							element: <EfilingPatentNextForm subdiv="efiling" />,
						},
						{
							path: 'detail/:_id',
							element: <EfilingPatentDetail />,
						},
						{
							path: 'result/:_id',
							element: <EfilingPatentResult subdiv="efiling" />,
						},
					],
				},
				{
					path: 'formality',
					permission: 'patent:all',
					children: [
						{
							path: '',
							element: <ListFormalityPatent />,
						},
						{
							path: 'detail/:_id',
							element: <FormalityPatentDetail />,
						},
						{
							path: 'result/:_id',
							element: <EfilingPatentResult subdiv="formality" />,
						},
						{
							path: 'create',
							element: <EfilingPatentForm subdiv="formality" />,
							// permission: "filing:add"
						},
						{
							path: 'create/:_id',
							element: <EfilingPatentNextForm subdiv="formality" />,
						},
					],
				},
				{
					path: 'publication',
					permission: 'patent:all',
					children: [
						{
							path: '',
							element: <ListPublicationPatent />,
						},
						{
							path: 'detail/:_id',
							element: <PublicationPatentDetail />,
						},
						{
							path: 'result/:_id',
							element: <EfilingPatentResult subdiv="publication" />,
						},
						{
							path: 'create',
							element: <EfilingPatentForm subdiv="publication" />,
							// permission: "filing:add"
						},
						{
							path: 'create/:_id',
							element: <EfilingPatentNextForm subdiv="publication" />,
						},
					],
				},
				{
					path: 'substantive',
					permission: 'patent:all',
					children: [
						{
							path: '',
							element: <ListSubstantivePatent />,
						},
						{
							path: 'detail/:_id',
							element: <SubstantivePatentDetail />,
						},
						{
							path: 'result/:_id',
							element: <EfilingPatentResult subdiv="substantive" />,
						},
						{
							path: 'create',
							element: <EfilingPatentForm subdiv="substantive" />,
							// permission: "filing:add"
						},
						{
							path: 'create/:_id',
							element: <EfilingPatentNextForm subdiv="substantive" />,
						},
					],
				},
				{
					path: 'officeaction',
					permission: 'patent:all',
					children: [
						{
							path: '',
							element: <ListOAPatent />,
						},
						{
							path: 'detail/:_id',
							element: <OAPatentDetail />,
						},
						{
							path: 'event/:_id',
							element: <OAEventPatentDetail />,
						},
						{
							path: 'result/:_id',
							element: <EfilingPatentResult subdiv="officeaction" />,
						},
						{
							path: 'create',
							element: <EfilingPatentForm subdiv="officeaction" />,
							// permission: "filing:add"
						},
						{
							path: 'create/:_id',
							element: <EfilingPatentNextForm subdiv="officeaction" />,
						},
					],
				},

				{
					path: 'registration',
					permission: 'patent:all',
					children: [
						{
							path: '',
							element: <ListRegistrasiPatent />,
						},
						{
							path: 'detail/:_id',
							element: <RegistrasiPatentDetail />,
						},
						{
							path: 'result/:_id',
							element: <EfilingPatentResult subdiv="registration" />,
						},
						{
							path: 'create',
							element: <EfilingPatentForm subdiv="registration" />,
						},
						{
							path: 'create/:_id',
							element: <EfilingPatentNextForm subdiv="registration" />,
						},
					],
				},
				{
					path: 'certificate',
					permission: 'patent:all',
					children: [
						{
							path: '',
							element: <ListSertifikatPatent />,
						},
						{
							path: 'detail/:_id',
							element: <SertifikatPatentDetail />,
						},
						{
							path: 'result/:_id',
							element: <EfilingPatentResult subdiv="certificate" />,
						},
						{
							path: 'create',
							element: <EfilingPatentForm subdiv="certificate" />,
							// permission: "filing:add"
						},
						{
							path: 'create/:_id',
							element: <EfilingPatentNextForm subdiv="certificate" />,
						},
					],
				},
				{
					path: 'renewal',
					permission: 'patent:all',
					children: [
						{
							path: '',
							element: <ListRenewalPatent />,
						},
						{
							path: 'detail/:_id',
							element: <RenewalPatentDetail />,
						},
						{
							path: 'result/:_id',
							element: <EfilingPatentResult renewal subdiv="renewal" />,
						},
						{
							path: 'create',
							element: <RenewalPatentForm />,
							// permission: "filing:add"
						},
						{
							path: 'create/:_id',
							element: <RenewalPatentNextForm />,
						},
					],
				},
				{
					path: 'recordal',
					permission: 'patent:all',
					children: [
						{
							path: '',
							element: <ListRecordalPatent />,
						},
						{
							path: 'detail/:_id',
							element: <RecordalPatentDetail />,
						},
						{
							path: 'result/:_id',
							element: <RecordalPatentResult />,
						},
						{
							path: 'create',
							element: <RecordalPatentForm />,
							// permission: "filing:add"
						},
						{
							path: 'create/:_id',
							element: <RecordalPatentNextForm />,
						},
					],
				},
				{
					path: 'search',
					permission: 'patent:all',
					children: [
						{
							path: '',
							element: <ListSearchPatent />,
						},
						{
							path: 'detail/:_id',
							element: <DetailSearchPatent />,
						},
						{
							path: 'create',
							element: <SearchFormPatent />,
						},
						{
							path: 'create/:_id',
							element: <SearchFormCompletePatent />,
						},
						{
							path: 'result/:_id',
							element: <ResultSearchPatent />,
						},
					],
				},
				{
					path: 'pph',
					permission: 'patent:all',
					children: [
						{
							path: '',
							element: <ListPphPatent />,
						},
						{
							path: 'detail/:_id',
							element: <PphPatentDetail />,
						},
						{
							path: 'result/:_id',
							element: <EfilingPatentResult subdiv="pph" />,
						},
					],
				},
				{
					path: 'aspek',
					permission: 'patent:all',
					children: [
						{
							path: '',
							element: <ListAspekPatent />,
						},
						{
							path: 'detail/:_id',
							element: <AspekPatentDetail />,
						},
						{
							path: 'result/:_id',
							element: <EfilingPatentResult subdiv="aspek" />,
						},
					],
				},
				{
					path: 'voluntary',
					permission: 'patent:all',
					children: [
						{
							path: '',
							element: <ListVolutaryPatent />,
						},
						{
							path: 'detail/:_id',
							element: <VolutaryPatentDetail />,
						},
						{
							path: 'result/:_id',
							element: <EfilingPatentResult subdiv="voluntary" />,
						},
					],
				},
			],
		},

		{
			path: 'event',
			permission: 'event:all',
			children: [
				{
					path: '',
					element: <EventList />,
				},
				{
					path: 'detail/:_id',
					element: <EventList preview={true} />,
				},
				{
					path: 'add',
					element: <EventAdd preview={true} />,
				},
			],
		},

		{
			path: 'tasks',
			permission: 'tasks:all',
			children: [
				{
					path: '',
					element: <RequestTaskList />,
				},
			],
		},

		// master data
		{
			path: 'master-data',
			children: [
				{
					path: 'company',
					permission: 'company:all',
					children: [
						{
							path: '',
							element: <CompanyList />,
						},
						{
							path: 'create',
							element: <AddCompany />,
						},
						{
							path: 'edit/:_id',
							element: <EditCompany />,
						},
					],
				},
				{
					path: 'consultant',
					permission: 'consultant:all',
					children: [
						{
							path: '',
							element: <ConsultantList />,
						},
						{
							path: 'form',
							permission: 'consultant:add',
							children: [
								{
									path: '',
									element: <FormConsultant />,
								},
								{
									path: ':_id',
									element: <FormConsultant />,
								},
							],
						},
					],
				},
				{
					path: 'departement',
					permission: 'division:all',
					element: <DepartementPage />,
				},
				{
					path: 'tasks',
					permission: 'tasks:all',
					children: [
						{
							path: '',
							element: <TasksList />,
						},
						{
							path: 'detail/:_id',
							permission: 'tasks:byid',
							element: <TasksList preview={true} />,
						},
					],
				},
			],
		},

		// tax rate
		{
			path: 'taxrate',
			permission: 'invoices:all',
			children: [
				{
					path: '',
					element: <TaxRateList />,
				},
				{
					path: 'form',
					permission: 'invoices:add',
					children: [
						{
							path: '',
							element: <TaxRateForm />,
						},
						{
							path: ':_id',
							element: <TaxRateForm />,
						},
					],
				},
			],
		},

		// notification
		{
			path: 'notifications',
			permission: 'notification:all',
			children: [
				{
					path: '',
					element: <NotificationPage />,
				},
			],
		},
	];

	return filterRoutes(routes, permissions);
};
export default Routes;
